module.exports = __webpack_public_path__ + "img/b-and-d-active.0d6483c3.svg";